import { render, staticRenderFns } from "./language-boxes.vue?vue&type=template&id=3f80cf10&"
import script from "./language-boxes.vue?vue&type=script&lang=js&"
export * from "./language-boxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Cristi\\Documents\\Work\\www\\tpdemo\\wp-content\\plugins\\translatepress\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3f80cf10', component.options)
    } else {
      api.reload('3f80cf10', component.options)
    }
    module.hot.accept("./language-boxes.vue?vue&type=template&id=3f80cf10&", function () {
      api.rerender('3f80cf10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/src/js/components/language-boxes.vue"
export default component.exports